import { useAuth } from "../context/AuthContext";

const Header = () => {
  const { logout, user } = useAuth(); // assuming user contains { username, role }

  return (
    <header className="sticky top-0 z-30 bg-[#121212] text-[#F5F1E9] flex items-center justify-between px-4 md:px-6 py-3 md:py-4 border-b border-[#3E3E3E] shadow-lg print:hidden font-poppins">
      {/* Logo + Company Name + User Info */}
      <div className="flex items-center gap-6">
        {/* <img
          src="https://your-company-logo-url.com/logo.png"
          alt="Company Logo"
          className="h-10 w-10 rounded-full object-cover shadow-md"
        /> */}
        {/* <h1 className="text-xl md:text-2xl font-playfair tracking-wide select-none">
          Azadi Jewellery
        </h1> */}

        {/* Username and Role */}
        {user && (
          <div className="flex flex-col text-sm md:text-base">
            <span className="font-semibold">Username: {user.username}</span>
            <span className="text-[#B4975A]">Role: {user.role}</span>
          </div>
        )}
      </div>

      {/* Logout Button */}
      <button
        onClick={logout}
        className="bg-[#B4975A] hover:bg-[#FFD700] text-[#121212] px-4 md:px-5 py-2 rounded-md font-semibold transition-colors shadow-md"
        aria-label="Logout"
      >
        Logout
      </button>
    </header>
  );
};

export default Header;
